var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-out" }, [
    _c(
      "div",
      { staticClass: "out-content" },
      [
        _c(
          "el-row",
          [
            _c("el-col", { domProps: { innerHTML: _vm._s(_vm.imgUrl) } }),
            _vm._v(" "),
            _c("el-col", [
              _c("span", { staticClass: "tips_text" }, [
                _vm._v(_vm._s(_vm.message))
              ])
            ]),
            _vm._v(" "),
            _vm.$route.params.status == 2
              ? _c(
                  "el-col",
                  { staticClass: "return_page" },
                  [
                    _c(
                      "el-button",
                      { attrs: { type: "primary" }, on: { click: _vm.goBack } },
                      [_vm._v("返回欢迎页")]
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fa229c30", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa229c30","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/loginOut/out.vue
// module id = null
// module chunks = 